import { render, staticRenderFns } from "./ManualSalesTable.vue?vue&type=template&id=4648d6b8&scoped=true"
import script from "./ManualSalesTable.vue?vue&type=script&lang=js"
export * from "./ManualSalesTable.vue?vue&type=script&lang=js"
import style0 from "./ManualSalesTable.vue?vue&type=style&index=0&id=4648d6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648d6b8",
  null
  
)

export default component.exports